/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Contract.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromData from 'Data/ViewsData.js'
import Address from './Address/view.js'
import Body from 'DesignSystem/Body/view.js'
import Checkbox from 'DesignSystem/Checkbox/logic.js'
import EffectiveDate from './EffectiveDate/view.js'
import FirstName from './FirstName/view.js'
import Info from 'DesignSystem/Info/view.js'
import LastName from './LastName/view.js'
import LegalName from './LegalName/view.js'
import React from 'react'
import SectionContract from 'DesignSystem/SectionContract/view.js'
import Title from 'DesignSystem/Title/view.js'
import TodaysDate from './TodaysDate/logic.js'
import { css } from "emotion"
Checkbox.displayName = 'CheckboxLogic'
TodaysDate.displayName = 'TodaysDateLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  flexGrow: 1,
flexShrink: 1,
flexBasis: "auto",
overflowY: "auto",
marginTop: 20,
paddingLeft: 50,
paddingRight: 50,
paddingBottom: 50})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
flexWrap: "wrap",
alignItems: "baseline",
marginTop: 30})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row",
height: 2,
width: "100%",
alignSelf: "center",
backgroundColor: "#e6e6e6",
marginTop: 200})
styles.Horizontal2 = css({label: 'Horizontal2',
  flexDirection: "row",
height: 2,
width: "100%",
alignSelf: "center",
backgroundColor: "#e6e6e6",
marginTop: 200})
styles.Horizontal3 = css({label: 'Horizontal3',
  flexDirection: "row",
alignItems: "baseline",
marginTop: 20,
flexWrap: "wrap"})
styles.Vertical1 = css({label: 'Vertical1',
  marginLeft: 40,
marginTop: 4})
styles.Horizontal4 = css({label: 'Horizontal4',
  flexDirection: "row",
alignItems: "baseline",
marginTop: 4})
styles.Vertical2 = css({label: 'Vertical2',
  marginTop: 30,
paddingTop: 16,
paddingBottom: 16,
paddingLeft: 50,
paddingRight: 16,
borderBottomLeftRadius: 8,
borderBottomRightRadius: 8,
borderTopLeftRadius: 8,
borderTopRightRadius: 8,
borderColor: "rgba(255,131,0,0.5)",
borderStyle: "solid",
borderWidth: 3})

export default function Contract({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  onChange,
value,
viewPath= "/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
}) {
    
    
    
    
    let data = fromData.useData({ viewPath, path: 'signature.company.has_accepted_agreement', 
context: 'signature',
})
    

  return (<React.Fragment
>
<div
 data-testid="Contract.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
 className={`views-block ${styles.Vertical}`}
>
<Title
 data-testid="Contract.Title"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ADMINISTRATIVE SERVICES AGREEMENT"
/>
<div
 data-testid="Contract.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
 className={`views-block ${styles.Horizontal}`}
>
<Body
 data-testid="Contract.Body"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 text="This ADMINISTRATIVE SERVICES AGREEMENT (“Agreement”) is made and entered into on"
 marginRight={4}
/>
<EffectiveDate
 data-testid="Contract.EffectiveDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/EffectiveDate`}
/>
<Body
 data-testid="Contract.Body:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 text="and outlines the relationship between"
 marginRight={4}
/>
<LegalName
 data-testid="Contract.LegalName"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/LegalName`}
/>
<Body
 data-testid="Contract.Body:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 text="(“Employer”)"
 marginTop={0}
 marginRight={4}
 marginLeft={4}
/>
<Body
 data-testid="Contract.Body:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 text="and GREYFINCH, LLC (“Greyfinch”)."
/>
</div>
<Body
 data-testid="Contract.Body:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 text="Greyfinch has established a program of group dental discounts (the “Discount”) for Employer to offer to Employer’s eligible employees and their eligible dependents (the “Participants”). The Discount is a discount dental program under the Arkansas Health Related Cash Discount Cards statutes (the “Program”). The Employer desires to contract with Greyfinch to provide certain benefits to the Participants with respect to the Discount and Greyfinch is willing to do so on the terms and conditions contained in this Agreement."
/>
<Body
 data-testid="Contract.Body:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 text="NOW, THEREFORE, for and in consideration of the foregoing recitals, and the covenants and agreements hereinafter set forth and other good and valuable consideration, the legal adequacy and sufficiency of which are hereby acknowledged, the parties, intending to be legally bound hereby, agree as follows:"
/>
<SectionContract
 data-testid="Contract.SectionContract"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="A."
 title="Term of Agreement"
 body="This Agreement shall be effective beginning on the Effective Date for an initial term of one year. The Agreement shall automatically renew for successive periods of one year each unless terminated in accordance with this Agreement. Each 12-month period measured from the Effective Date is referred to as a “Contract Year.”"
/>
<SectionContract
 data-testid="Contract.SectionContract:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="B."
 title="Responsibilities of the Employer"
 body="The Employer shall have the following duties and obligations under this Agreement:"
/>
<SectionContract
 data-testid="Contract.SectionContract:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="1."
 title="Plan Administrator"
 body="The Employer is the Plan Administrator and the named fiduciary of the Plan under the provisions of the Employee Retirement Income Security Act of 1974, as amended, (“ERISA”) with the authority to control the operation and administration of the Plan. The Plan Administrator’s powers and duties include, but are not limited to, the following:"
/>
<SectionContract
 data-testid="Contract.SectionContract:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="i."
 title="Plan Interpretation"
 body="The Employer shall have the responsibility and discretionary authority to decide all questions of eligibility and interpret the provisions of the Plan for purposes of resolving any inconsistency or ambiguity, correcting any error or supplying information to correct any omitted term."
/>
<SectionContract
 data-testid="Contract.SectionContract:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="ii."
 title="Disclosures to Plan Participants"
 body="Employer shall be responsible to communicate to Participants all information required by ERISA and other applicable law concerning the Plan, including, without limitation, Summary Plan Descriptions, Summaries of Material Modifications, notices of material benefit reductions and Summary Annual Reports. The Employer shall also provide the following information required by law (MCLA 550.932): (a) what benefits are provided under the Plan; (b) changes in benefits, (c) the fact that individuals covered by the Plan are not insured"
/>
<SectionContract
 data-testid="Contract.SectionContract:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="iii."
 title="Information"
 body="The Employer shall provide all information reasonably requested by Greyfinch to perform its duties and to calculate its fees under this Agreement. Specifically, and without limitation:"
/>
<SectionContract
 data-testid="Contract.SectionContract:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={60}
 number="1."
 body="Prior to the effective date of this Agreement, the Employer shall provide Greyfinch with a complete and accurate enrollment list for each Plan.  This can be done by entering the required data in the Greyfinch software.  Employer may also grant account access to their broker or other third party in order to make similar administrative changes."
/>
<SectionContract
 data-testid="Contract.SectionContract:7"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={60}
 number="2."
 body="On or before the tenth day of each month, the Employer shall provide Greyfinch with a list of persons commencing or terminating participation as of the first day of the following month.  This can be done by entering the required data in the Greyfinch software."
/>
<SectionContract
 data-testid="Contract.SectionContract:8"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="iv."
 title="Reporting"
 body="The Employer shall be responsible to make and file all Form 5500 reports and any other returns and reports concerning the Plan (and the Trust, if any), required by ERISA, the Internal Revenue Code and other applicable law."
/>
<SectionContract
 data-testid="Contract.SectionContract:9"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="v."
 title="Compliance with Law"
 body="Except as specifically provided in this Agreement, the Employer shall be responsible for compliance with applicable federal, state and local legislation and regulations."
/>
<SectionContract
 data-testid="Contract.SectionContract:10"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="vi."
 title="Invoicing and Payments"
 body="Unless otherwise provided in applicable exhibit, Greyfinch shall invoice Employer for all fees provided in Exhibit A."
/>
<SectionContract
 data-testid="Contract.SectionContract:11"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="2."
 title="Expenses"
 body="The Employer shall be responsible for all administrative expenses of the Plan, including without limitation, fees owing pursuant to this Agreement; fees of any legal counsel, accountant, auditor, actuary, health consultant or other expert appointed by the Employer pursuant to this Agreement; and taxes or other governmental fees assessed against the Plan."
/>
<SectionContract
 data-testid="Contract.SectionContract:12"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="C."
 title="Responsibilities of Greyfinch"
 body="During the initial Contract Year and any renewal Contract Year, Greyfinch shall provide the following services:"
/>
<SectionContract
 data-testid="Contract.SectionContract:13"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="1."
 title="Preparation of Document Template"
 body="Greyfinch shall provide the Employer with the standard access necessary to administer enrollment through the Greyfinch software."
/>
<SectionContract
 data-testid="Contract.SectionContract:14"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="2."
 title="Registration"
 body="Greyfinch shall assist the Employer in the registration of employees and dependents by providing the Employer with the tools and resources necessary to self-administer the registration through the Greyfinch software."
/>
<SectionContract
 data-testid="Contract.SectionContract:15"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="3."
 title="Confidentiality"
 body="Greyfinch shall maintain as confidential all reports and other information furnished, obtained or developed in respect to its services under this Agreement and as provided under the executed HIPAA Business Associate Agreement between the Employer and Greyfinch, unless the person to whom such information pertains consents in writing to disclosure or unless disclosure is required or permitted by law. Legally permitted disclosure includes, without limitation, disclosure for claims adjudication and verification purposes, for other proper Discount administration, for an ERISA audit, pursuant to statute or court order for the production of evidence or the discovery thereof, or disclosure to an insurer, plan fiduciary or the Commissioner of Insurance."
/>
<SectionContract
 data-testid="Contract.SectionContract:16"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="4."
 title="Legal Action"
 body="Greyfinch shall notify the Employer if Greyfinch obtains knowledge of any legal action involving the Discount, the Employer or Greyfinch due to the operation of the Discount. Greyfinch shall provide all reasonable records requested by the Employer and cooperate with the Employer in the defense of any such legal action."
/>
<SectionContract
 data-testid="Contract.SectionContract:17"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="D."
 title="Limitations on Services"
 body="Greyfinch does not assume any obligations other than those responsibilities expressly stated in this Agreement. In particular, Greyfinch does not have the following obligations:"
/>
<SectionContract
 data-testid="Contract.SectionContract:18"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="1."
 title="Not a Fiduciary"
 body="Greyfinch is not a Plan Administrator or administrator as defined in ERISA Section 3(16), plan sponsor, trustee of any assets associated with the Plan, or a fiduciary of the Plan as defined in Section 3(21) of ERISA. Greyfinch shall have no discretionary authority or control over the management of the Discount, shall exercise no discretion or control with respect to the management or disposition of plan funds and shall not render investment advice."
/>
<SectionContract
 data-testid="Contract.SectionContract:19"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="2."
 title="Not a Payment Guarantor"
 body="Greyfinch shall not be liable, nor advance its own funds under the Discount. The Discount requires participants to pay for any services rendered by a provider who contracts with Greyfinch (“Providers”).  The services will be billed to participants at a discounted price, as outlined in the Discount documents."
/>
<SectionContract
 data-testid="Contract.SectionContract:20"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="3."
 title="Compliance"
 body="Greyfinch is not responsible for qualification or compliance of the Discount with ERISA, the Internal Revenue Code and any other applicable laws, federal, state or local, for which the Discount Sponsor or Discount Administrator is responsible by law."
/>
<SectionContract
 data-testid="Contract.SectionContract:21"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="4."
 title="Expenses"
 body="Greyfinch is not responsible for payment of any expense of the Discount, including, but not limited to, the fees of an attorney, accountant and other individual or entity not employed by Greyfinch who provides services to the Discount at the request of or with the prior consent of the Employer."
/>
<SectionContract
 data-testid="Contract.SectionContract:22"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="5."
 title="Software"
 body="Employer acknowledges that Greyfinch will use a software system to manage the Discount."
/>
<SectionContract
 data-testid="Contract.SectionContract:23"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="E."
 title="Consideration"
 body="As consideration for the services provided by Greyfinch set forth in this Agreement, Employer shall participate in the Discount, along with all other good and fair consideration."
/>
<SectionContract
 data-testid="Contract.SectionContract:24"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="F."
 title="Termination of Agreement"
 body="This Agreement shall be terminated at the earliest date specified below:"
/>
<SectionContract
 data-testid="Contract.SectionContract:25"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="1."
 title="Mutual Agreement"
 body="Any date mutually agreed upon by the parties."
/>
<SectionContract
 data-testid="Contract.SectionContract:26"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="2."
 title="Breach of Agreement"
 body="In the event of a breach of this Agreement, 30 days after the non-breaching party gives the other party notice of the breach unless the breach is cured within such 30-day period."
/>
<SectionContract
 data-testid="Contract.SectionContract:27"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="3."
 title="End of Contract Year"
 body="As of the last day of a Contract Year, if either party gives at least 30 days’ prior written notice to the other of its intent to terminate."
/>
<SectionContract
 data-testid="Contract.SectionContract:28"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="G."
 title="Discount for Participants After Termination"
 body="Upon termination of this Agreement, Employer’s participants shall no longer have any right or claim or access to the Discount.  No services performed after the date of termination shall be eligible to receive discounted prices."
/>
<SectionContract
 data-testid="Contract.SectionContract:29"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="H."
 title="Indemnification"
 body="The following shall apply throughout the term of this Agreement and after termination or expiration of this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:30"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="1."
 title="Reliance on Representations of Others"
 body="The Employer acknowledges and agrees that, in order to fulfill its duties under this Agreement, Greyfinch must rely on oral or written representations of the Employer’s officers and employees, participants in the Discount, and any agents and providers of service to the Discount and Discount participants and has no duty to verify or independently audit such information. The Employer agrees to hold harmless Greyfinch and its directors, officers and employees from and against any loss or damage to the Discount, the Employer or Greyfinch due to its good faith reliance on these oral or written representations."
/>
<SectionContract
 data-testid="Contract.SectionContract:31"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="2."
 title="Indemnity"
 body="The Employer agrees to indemnify and hold harmless Greyfinch and its directors, officers, employees and agents from and against all claims, liabilities, lawsuits, settlements, judgments, damages, costs, penalties, and expenses, including attorneys’ fees and costs, which are or may be incurred by Greyfinch arising out of or in connection with the performance of its duties under this Agreement except to the extent the liability was caused by the gross negligence, fraud or intentional misconduct of Greyfinch, its directors, officers, employees or agents, in the performance of such duties. Greyfinch may retain, at its own expense, an attorney of its choice to represent it in any action described above without impairing in any way the indemnification contained in this section."
/>
<SectionContract
 data-testid="Contract.SectionContract:32"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="I."
 title="Notices"
 body="All notices, requests, and other communications shall be in writing and mailed, postage prepaid, to the other party. All notices pursuant to this Agreement shall be effective and deemed received upon the earlier of actual receipt by an officer of the party to whom the notice is addressed or three days after the notice is either deposited in first class mail or mailed by certified or registered mail, postage prepaid."
/>
<SectionContract
 data-testid="Contract.SectionContract:33"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="J."
 title="Independent Contractor"
 body="In performing its obligations hereunder, Greyfinch, its directors, officers, employees, and agents shall be deemed to be acting as an independent contractor and not as an employee or agent of the Employer. Neither Greyfinch, its directors, officers, employees, and agents, nor the Employer shall have the power or authority to act for or on behalf of, or to bind the other party, except as may be set forth herein."
/>
<SectionContract
 data-testid="Contract.SectionContract:34"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="K."
 title="Assignment"
 body="Except as provided in the next section, neither party shall assign its rights or obligations hereunder without the prior written consent of the other, provided however, that Greyfinch may assign the Agreement to a related entity or to any successor in a corporate reorganization or restructuring, including the purchaser of substantially all of Greyfinch’s assets, without consent."
/>
<SectionContract
 data-testid="Contract.SectionContract:35"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="L."
 title="Delegation of Functions"
 body="Notwithstanding Section K. above, the Employer acknowledges and agrees that Greyfinch may assign, subcontract or otherwise delegate any of its functions or duties to be performed hereunder to another qualified person or entity, provided that such assignment, subcontract or delegation will not relieve Greyfinch of its obligations under this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:36"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="M."
 title="Waiver"
 body="Failure to enforce any provision of this Agreement does not alter or waive the provision or affect the future enforceability of the provision."
/>
<SectionContract
 data-testid="Contract.SectionContract:37"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="N."
 title="Governing Law"
 body="This Agreement shall be construed and governed in accordance with the laws of the State of Arkansas unless pre-empted by ERISA or other federal law."
/>
<SectionContract
 data-testid="Contract.SectionContract:38"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="O."
 title="Third Party Beneficiaries"
 body="This Agreement shall not confer any rights, remedies, claims or obligations on third parties except as expressly provided herein."
/>
<SectionContract
 data-testid="Contract.SectionContract:39"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="P."
 title="Entire Agreement"
 body="This Agreement and any Exhibits hereto contains the entire agreement between the parties and may be amended only by writing signed by both parties. If any provision of this Agreement is held to be invalid or unenforceable, the remaining provisions of this Agreement shall remain in full force and effect."
/>
<SectionContract
 data-testid="Contract.SectionContract:40"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="Q."
 title="Severability"
 body="The invalidity of any provision of this Agreement shall not impair the validity of any other provision. If any provision of this Agreement is determined by a court of competent jurisdiction to be unenforceable, that provision will be deemed severable and the Agreement will be enforced with that provision severed or as modified by the court; provided, however, that if such severance or modification has or will have a material adverse effect on either party, the party so affected shall have the right to terminate this Agreement upon at least 30 days’ prior written notice to the other party."
/>
<SectionContract
 data-testid="Contract.SectionContract:41"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="R."
 title="Force Majeure"
 body="If Greyfinch is unable to perform its obligations under this Agreement by reason of war, fire, insurrection, strike, riot, earthquake, hurricane, natural disaster or act of God (an “Interruption”), this Agreement or such portions hereof as Greyfinch is unable to perform shall be suspended until such time as the Interruption has been resolved. If the suspension continues for more than 60 days, the Employer may terminate this Agreement upon 30 days’ prior written notice."
/>
<SectionContract
 data-testid="Contract.SectionContract:42"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 number="S."
 title="Tax Consequences"
 body="Greyfinch does not warrant or guarantee the tax consequences of this Discount to participants or the Employer. The Employer is advised to consult its legal counsel or tax advisors concerning the tax effects associated with this Discount."
/>
<Body
 data-testid="Contract.Body:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 text="IN WITNESS WHEREOF, the parties have executed this Administrative Services Agreement as of the date set forth in the preface."
/>
<div
 data-testid="Contract.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
 className={`views-block ${styles.Horizontal1}`}
/>
<Title
 data-testid="Contract.Title:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="Exhibit A - Invoicing and Payments"
 marginTop={200}
/>
<SectionContract
 data-testid="Contract.SectionContract:43"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number={1}
 title="Invoicing"
 body="Shortly after Employer onboards to Greyfinch’s Direct Dental Care platform, Employer will receive an email invitation to create an account for invoicing. Employer will be prompted to set up a bank account for payments to be drafted via Automated Clearing House (ACH) per the schedule below. ACH payments are required. Paper checks will not be accepted."
/>
<SectionContract
 data-testid="Contract.SectionContract:44"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number={2}
 title="2nd Wednesday of the Month"
 body="Email notification sent from Greyfinch to Employer to remind of tasks that might need to be done to finalize invoicing for the current month. The email will also include an estimated amount to be drafted on the 20th based on the current roster and any pending enrollments."
/>
<SectionContract
 data-testid="Contract.SectionContract:45"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number={3}
 title="20th of the Month"
 body="ACH transaction is processed for payment based on Employer’s active roster."
/>
<SectionContract
 data-testid="Contract.SectionContract:46"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number={3}
 title="Failure to make payments"
 body="Employer acknowledges that failure to make payments in a timely manner may result in termination of this agreement. Payments are considered late if not paid by the 20th of each month."
/>
<div
 data-testid="Contract.Horizontal:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
 className={`views-block ${styles.Horizontal2}`}
/>
<Title
 data-testid="Contract.Title:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="BUSINESS ASSOCIATE AGREEMENT"
 marginTop={200}
/>
<div
 data-testid="Contract.Horizontal:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
 className={`views-block ${styles.Horizontal3}`}
>
<Body
 data-testid="Contract.Body:7"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="This Business Associate Agreement"
/>
<Body
 data-testid="Contract.Body:8"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="(the “Agreement”), is made as of"
/>
<TodaysDate
 data-testid="Contract.TodaysDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/TodaysDate`}
/>
<Body
 data-testid="Contract.Body:9"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="(the “Effective Date”),"
/>
<Body
 data-testid="Contract.Body:10"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="by and between"
/>
<LegalName
 data-testid="Contract.LegalName:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/LegalName`}
/>
<Body
 data-testid="Contract.Body:11"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginLeft={4}
 marginRight={4}
 text="(“Covered Entity”) and Greyfinch,"
/>
<Body
 data-testid="Contract.Body:12"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="LLC (collectively"
/>
<Body
 data-testid="Contract.Body:13"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="“Business Associate”)"
/>
<Body
 data-testid="Contract.Body:14"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="to comply with privacy"
/>
<Body
 data-testid="Contract.Body:15"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="standards adopted"
/>
<Body
 data-testid="Contract.Body:16"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="by the U.S. Department"
/>
<Body
 data-testid="Contract.Body:17"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="of Health and Human"
/>
<Body
 data-testid="Contract.Body:18"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="Services as they"
/>
<Body
 data-testid="Contract.Body:19"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginTop={0}
 marginRight={4}
 text="may be amended from time to time, 45 C.F.R. parts 160 and 164 (“the Privacy Rule”) and security standards adopted by the U.S. Department of Health and Human Services as they may be amended from time to time, 45 C.F.R. parts 160, 162 and 164, subpart C (“the Security Rule”), and the Health Information Technology for Economic and Clinical Health (HITECH) Act, Title XIII of Division A and Title IV of Division B of the American Recovery and Reinvestment Act of 2009 and regulations promulgated there under and any applicable state confidentiality laws.  Business Associate and Covered Entity are collectively referred to herein as the “Parties.”"
/>
</div>
<Title
 data-testid="Contract.Title:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="RECITALS"
 marginTop={30}
/>
<SectionContract
 data-testid="Contract.SectionContract:47"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="WHEREAS,"
 body="the Business Associate provides Direct Dental Care benefits software and administrative services, and in connection with those services, Business Associate may use or disclose certain individual health information that is subject to protection under the Health Insurance Portability and Accountability Act of 1996, as amended (“HIPAA”), the Privacy Rule, and the Security Rule; and"
/>
<SectionContract
 data-testid="Contract.SectionContract:48"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="WHEREAS,"
 body="the Parties wish to comply with the requirements of: (i) the implementing regulations at 45 C.F.R Parts 160, 162 and 164 (i.e., the HIPAA Privacy, Security, Electronic Transactions, Breach Notification, and Enforcement Rules (“the implementing Regulations”)), (ii) the requirements of the Health Information Technology for Economic and Clinical Health Act, as incorporated in the American Recovery and Reinvestment Act of 2009 (“the HITECH Act”) that are applicable to business associates, and (iii) the requirements of the final modifications to the HIPAA Privacy, Security, Enforcement and Breach Notification Rules as issued on January 25, 2013, and effective [MONTH] 26, 2013 (75 Fed. Reg. 5566 (Jan. 25, 2013)) (“the Final Regulations”)."
/>
<SectionContract
 data-testid="Contract.SectionContract:49"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="NOW THEREFORE,"
 body="in consideration of the mutual covenants and conditions contained herein and other good and valuable consideration, the receipt and sufficiency of which is hereby acknowledged, the Parties agree as follows:"
/>
<Title
 data-testid="Contract.Title:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE I DEFINITIONS"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:50"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="1.1."
 title="HIPAA Rules Definitions"
 body="The following terms used in this Agreement shall have the same meaning as those terms in the HIPAA Rules: Data Aggregation, Disclosure, Health Care Operations, Individual, Minimum Necessary, Notice of Privacy Practices, Protected Health Information, Required by Law, Secretary, Security Incident, Subcontractor, and Use."
/>
<SectionContract
 data-testid="Contract.SectionContract:51"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="1.2."
 title="Additional Definitions"
 body="The following terms used in this Agreement shall have the meanings provided below."
/>
<SectionContract
 data-testid="Contract.SectionContract:52"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 body="“Breach” shall mean the unauthorized acquisition, access, use, or disclosure of PHI which compromises the security or privacy of such information, except where an unauthorized person to whom such information is disclosed would not reasonably have been able to retain such information."
/>
<SectionContract
 data-testid="Contract.SectionContract:53"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 body="“Business Associate” shall generally have the same meaning as the term “business associate” at 45 CFR 160.103."
/>
<SectionContract
 data-testid="Contract.SectionContract:54"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 body="“Covered Entity” shall generally have the same meaning as the term “covered entity” at 45 CFR 160.103."
/>
<SectionContract
 data-testid="Contract.SectionContract:55"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 body="“Designated Record Set” shall mean a group of records maintained by or for a Covered Entity that is:  (i) the medical records and billing records about Individuals maintained by or for a covered health care provider; (ii) the enrollment, payment, claims adjudication, and case or medical management record systems maintained by or for a health plan; or (iii) used, in whole or in part, by or for the covered entity to make decisions about Individuals.  For purposes of this definition, the term “record” means any item, collection, or grouping of information that includes PHI and is maintained, collected, used, or disseminated by or for a covered entity."
/>
<SectionContract
 data-testid="Contract.SectionContract:56"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 body="The Privacy Rule and the Security Rule and amendments codified and promulgated by the HITECH Act are referred to collectively herein as “HIPAA Rules.”"
/>
<SectionContract
 data-testid="Contract.SectionContract:57"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="F."
 body="“Protected Health Information” or PHI shall mean individually identifiable health information that is transmitted or maintained in any form or medium."
/>
<Title
 data-testid="Contract.Title:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE II PERMITTED USES"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:58"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="2.1."
 title="Permitted Uses and Disclosures by Business Associate"
 body="Except as otherwise limited in this Agreement, Business Associate may use or disclose Protected Health Information to perform functions, activities, or services for, or on behalf of, Covered Entity as specified in this Agreement (the “Services”), provided that such use or disclosure would not violate the HIPAA Rules if done by Covered Entity or the minimum necessary policies and procedures of the Covered Entity.  Also, Business Associate may use PHI to report violations of law to appropriate Federal and State authorities, consistent with the HIPAA Rules."
/>
<SectionContract
 data-testid="Contract.SectionContract:59"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 title="Use"
 body="Business Associate will not, and will ensure that its directors, officers, employees, contractors, and other agents do not, use PHI other than as permitted or required by Business Associate to perform the Services or as required by law, but in no event in any manner that would constitute a violation of the Privacy Standards or Security Standards if used by Covered Entity."
/>
<SectionContract
 data-testid="Contract.SectionContract:60"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 title="Disclosure"
 body="Business Associate will not, and will ensure that its directors, officers, employees, contractors, and other agents do not, disclose PHI other than as permitted pursuant to this Agreement or as required by law, but in no event disclose PHI in any manner that would constitute a violation of the Privacy Standards or Security Standards if disclosed by Covered Entity."
/>
<SectionContract
 data-testid="Contract.SectionContract:61"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 title="Data Aggregation"
 body="In the event that Business Associate works for more than one Covered Entity, Business Associate is permitted to use and disclose PHI for data aggregation purposes, however, only in order to analyze data for permitted health care operations, and only to the extent that such use is permitted under HIPAA Rules."
/>
<SectionContract
 data-testid="Contract.SectionContract:62"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 title="De-identified Information"
 body="Business Associate may use and disclose de-identified health information if the PHI is de-identified in compliance with the HIPAA Rules."
/>
<Title
 data-testid="Contract.Title:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE III OBLIGATIONS OF COVERED ENTITY"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:63"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="3.1."
 title="Obligations of Covered Entity"
 body="If applicable, Covered Entity shall:"
/>
<SectionContract
 data-testid="Contract.SectionContract:64"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 body="provide Business Associate a copy of its Notice of Privacy Practices (“Notice”) produced by Covered Entity in accordance with 45 C.F.R. 164.520 as well as any changes to such Notice;"
/>
<SectionContract
 data-testid="Contract.SectionContract:65"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 body="provide Business Associate with any changes in, or revocation of, authorizations by Individuals relating to the use and/or disclosure of PHI, if such changes affect Business Associate’s permitted or required uses and/or disclosures;"
/>
<SectionContract
 data-testid="Contract.SectionContract:66"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 body="notify Business Associate of any restriction to the use and/or disclosure of PHI to which Covered Entity has agreed in accordance with 45 C.F.R. 164.522, to the extent that such restriction may affect Business Associate’s use or disclosure of PHI;"
/>
<SectionContract
 data-testid="Contract.SectionContract:67"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 body="not request Business Associate to use or disclose PHI in any manner that would not be permissible under the Privacy Rule if done by the Covered Entity;"
/>
<SectionContract
 data-testid="Contract.SectionContract:68"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 body="notify Business Associate of any amendment to PHI to which Covered Entity has agreed that affects a Designated Record Set maintained by Business Associate;"
/>
<SectionContract
 data-testid="Contract.SectionContract:69"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="F."
 body="if Business Associate maintains a Designated Record Set, provide Business Associate with a copy of its policies and procedures related to an Individual’s right to: access PHI; request an amendment to PHI; request confidential communications of PHI; or request an accounting of disclosures of PHI; and"
/>
<SectionContract
 data-testid="Contract.SectionContract:70"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="G."
 body="notify Individuals of any Breach Required by Law."
/>
<Title
 data-testid="Contract.Title:7"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE IV OBLIGATIONS OF BUSINESS ASSOCIATE"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:71"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="4.1."
 title="Obligations of Business Associate"
 body="Business Associate agrees to comply with applicable federal and state confidentiality and security laws, specifically the provisions of the HIPAA Rules applicable to business associates.  Additionally, when applicable, Business Associate shall:"
/>
<SectionContract
 data-testid="Contract.SectionContract:72"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 body="not use or further disclose Protected Health Information other than as permitted or required by this Agreement or as Required by Law."
/>
<SectionContract
 data-testid="Contract.SectionContract:73"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 body="provide information and training to members of its workforce using or disclosing PHI regarding the confidentiality requirements of the HIPAA Rules and this Agreement;"
/>
<SectionContract
 data-testid="Contract.SectionContract:74"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 body="obtain reasonable assurances from the person or entity to whom the PHI is disclosed that: (a) the PHI will be held confidential and further used and disclosed only as required by law or for the purpose for which it was disclosed to the person or entity; and (b) the person or entity will notify Business Associate of any instances of which it is aware in which confidentiality of the PHI has been breached;"
/>
<SectionContract
 data-testid="Contract.SectionContract:75"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="D."
 body="mitigate, to the extent practicable, any harmful effect that is known to the Business Associate of a use or disclosure of PHI by the Business Associate in violation of the requirements of the Agreement"
/>
<SectionContract
 data-testid="Contract.SectionContract:76"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="E."
 body="notify the designated Privacy Officer of Covered Entity of any instances of which it is aware in which the PHI is used or disclosed for a purpose that is not otherwise provided for in this Agreement or for a purpose not expressly permitted by the HIPAA Rules;"
/>
<SectionContract
 data-testid="Contract.SectionContract:77"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="F."
 body="Business Associate shall maintain appropriate safeguards to ensure that PHI is not used or disclosed other than as provided by this Agreement or as required by law.  Business Associate shall implement administrative, physical and technical safeguards that reasonably and appropriately protect the confidentiality, integrity, and availability of any paper or electronic PHI it creates, receives, maintains, or transmits on behalf of Covered Entity;"
/>
<SectionContract
 data-testid="Contract.SectionContract:78"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="i."
 body="Implement policies and procedures to prevent, detect, contain, and correct security violations;"
/>
<SectionContract
 data-testid="Contract.SectionContract:79"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="ii."
 body="Implement policies and procedures to limit physical access to its electronic information systems and the facility or facilities in which they are housed, while ensuring that properly authorized access is allowed;"
/>
<SectionContract
 data-testid="Contract.SectionContract:80"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="iii."
 body="Implement technical policies and procedures for electronic information systems that maintain electronic protected health information to allow access only to those persons or software programs that have been granted access rights; and"
/>
<SectionContract
 data-testid="Contract.SectionContract:81"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="iv."
 body="Implement reasonable written policies and procedures to comply with the standards, implementation specifications, or other requirements of the policies listed above."
/>
<SectionContract
 data-testid="Contract.SectionContract:82"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="G."
 body="Business Associate shall assure that all PHI is secured when accessed by Business Associate’s employees, agents, or subcontractor.  Any access to PHI by Business Associate’s employees, agents or subcontractors shall be limited to legitimate business needs while working with PHI;"
/>
<SectionContract
 data-testid="Contract.SectionContract:83"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="H."
 body="Business Associate shall ensure that all uses and disclosures of PHI are subject to the principle of “minimum necessary use and disclosure,” i.e., that only PHI that is the minimum necessary to accomplish the intended purpose of the use, disclosure, or request is used or disclosed; and, the use of limited data sets when possible;"
/>
<SectionContract
 data-testid="Contract.SectionContract:84"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="I."
 body="If Business Associate discloses PHI received from Covered Entity, or created or received by Business Associate on behalf of Covered Entity, to agents, including a subcontractor, Business Associate shall require the agent or subcontractor to agree to the same restrictions and conditions as apply to Business Associate under this Agreement.  Business Associate agrees that, as required by HIPAA, Business Associate will enter into a written agreement with all subcontractors that: (i) requires them to comply with the Privacy and Security Rule provisions of this Agreement in the same manner as required of Business Associate, and (ii) notifies such subcontractors that they will incur liability under the HIPAA Requirements for non-compliance with such provisions. Accordingly, Business Associate shall ensure that all subcontractors agree in writing to the same privacy and security restrictions, conditions and requirements that apply to Business Associate with respect to PHI. Business Associate shall ensure that any agent, including a subcontractor, agrees to implement reasonable and appropriate safeguards to protect the confidentiality, integrity, and availability of the paper or electronic PHI that it creates, receives, maintains, or transmits on behalf of the Covered Entity;"
/>
<SectionContract
 data-testid="Contract.SectionContract:85"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="J."
 body="Except as otherwise specified herein, Business Associate shall make available its internal practices, books, and records relating to the use and disclosure of PHI, received from, or created or received on behalf of by Business Associate, Covered Entity to the Secretary or his or her agents for the purpose of determining Covered Entity’s compliance with the HIPAA Rules, or any other health oversight agency, or to Covered Entity;"
/>
<SectionContract
 data-testid="Contract.SectionContract:86"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="K."
 body="Business Associate shall abide by the limitations of Covered Entity’s Notice of which it has knowledge. Any use or disclosure permitted by this Agreement may be amended by changes to Covered Entity’s Notice; provided, however, that the amended Notice shall not affect permitted uses and disclosures on which Business Associate relied prior to receiving notice of such amended Notice;"
/>
<SectionContract
 data-testid="Contract.SectionContract:87"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="L."
 body="Business Associate expressly recognizes that Covered Entity has certain reporting and disclosure obligations to the Secretary and the Individual in case of a security breach of unsecured PHI.  Where Business Associate accesses, maintains, retains, modifies, records, stores, destroys, or otherwise holds, uses or discloses unsecured paper or electronic PHI, Business Associate, immediately following the discovery of a breach of such information, shall notify Covered Entity of such breach.  Initial notification of the breach does not need to be in compliance with Sub Title D Title IV Section 13402 of the HITECH Act; however, Business Associate must provide Covered Entity with all information necessary for Covered Entity to comply with Sub Title D Title IV Section 13402 of the HITECH Act without reasonable delay, and in no case later than thirty (30) days following the discovery of the Breach."
/>
<SectionContract
 data-testid="Contract.SectionContract:88"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="M."
 body="Business Associate agrees to only use or disclose PHI received by the Business Associate in its capacity as a Business Associate to the Covered Entity for Business Associate’s own operations if:"
/>
<SectionContract
 data-testid="Contract.SectionContract:89"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="i."
 body="the use relates to the proper management and administration of the Business Associate or to carry out legal responsibilities of the Business Associate, or data aggregation services relating to the health care operations of the Covered Entity; or"
/>
<SectionContract
 data-testid="Contract.SectionContract:90"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="ii."
 body="the disclosure of information received in such capacity will be made in connection with a function, responsibility, or services to be performed by the Business Associate, and such disclosure is required by law or the Business Associate obtains reasonable assurances from the person to whom the information is disclosed that it will be held confidential and the person agrees to notify the Business Associate of any breaches of confidentiality."
/>
<SectionContract
 data-testid="Contract.SectionContract:91"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="N."
 body="Business Associate agrees to report to the Covered Entity any use or disclosure of the Protected Health Information not provided for by this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:92"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="O."
 body="Business Associate agrees to report to the Covered Entity as soon as possible any “security incident” of which it becomes aware, as such term is defined in the HIPAA Security Rule."
/>
<Title
 data-testid="Contract.Title:8"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE V INDIVIDUAL RIGHTS"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:93"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="5.1."
 title="Individual Rights Regarding Designated Record Sets"
 body="If Business Associate maintains a Designated Record Set on behalf of Covered Entity, Business Associate agrees as follows:"
/>
<SectionContract
 data-testid="Contract.SectionContract:94"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="A."
 title="Individual Right to Copy or Inspection"
 body="Business Associate agrees that if it maintains a Designated Record Set for Covered Entity that is not maintained by Covered Entity, it will permit an Individual to inspect or copy PHI about the Individual in that set as directed by Covered Entity to meet the requirements of 45 C.F.R. § 164.524.  If the PHI is in electronic format, the Individual shall have a right to obtain a copy of such information in electronic format and, if the Individual chooses, to direct that an electronic copy be transmitted directly to an entity or person designated by the individual in accordance with HITECH section 13405(e).  Under the Privacy Rule, Covered Entity is required to take action on such requests as soon as possible, but not later than thirty (30) days following receipt of the request.  Business Associate agrees to make reasonable efforts to assist Covered Entity in meeting this deadline.  The information shall be provided in the form or format requested if it is readily producible in such form or format; or in summary, if the Individual has agreed in advance to accept the information in summary form.  A reasonable, cost-based fee for copying health information may be charged.  If Covered Entity maintains the requested records, Covered Entity, rather than Business Associate shall permit access according to its policies and procedures implementing the Privacy Rule."
/>
<SectionContract
 data-testid="Contract.SectionContract:95"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="B."
 title="Individual Right to Amendment"
 body="Business Associate agrees, if it maintains PHI in a Designated Record Set, to make amendments to PHI at the request and direction of Covered Entity pursuant to 45 C.F.R. 164.526.  If Business Associate maintains a record in a Designated Record Set that is not also maintained by Covered Entity, Business Associate agrees that it will accommodate an Individual’s request to amend PHI only in conjunction with a determination by Covered Entity that the amendment is appropriate according to 45 C.F.R. § 164.526."
/>
<SectionContract
 data-testid="Contract.SectionContract:96"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="C."
 title="Accounting of Disclosures"
 body="Business Associate agrees to maintain documentation of the information required to provide an accounting of disclosures of PHI, whether PHI is paper or electronic format, in accordance with 45 C.F.R. § 164.528 and HITECH Sub Title D Title VI Section 13405(c), and to make this information available to Covered Entity upon Covered Entity’s request, in order to allow Covered Entity to respond to an Individual’s request for accounting of disclosures.  Under the Privacy Rule, Covered Entity is required to take action on such requests as soon as possible but not later than sixty (60) days following receipt of the request.  Business Associate agrees to use its best efforts to assist Covered Entity in meeting this deadline but not later than forty-five (45) days following receipt of the request.  Such accounting must be provided without cost to the Individual or Covered Entity if it is the first accounting requested by an Individual within any 12 month period; however, a reasonable, cost-based fee may be charged for subsequent accountings if Business Associate informs the individual in advance of the fee and is afforded an opportunity to withdraw or modify the request.  Such accounting is limited to disclosures that were made in the six (6) years prior to the request (not including disclosures prior to the compliance date of the Privacy Rule) and shall be provided for as long as Business Associate maintains the PHI."
/>
<Title
 data-testid="Contract.Title:9"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE VI TERM AND TERMINATION"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:97"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="6.1."
 title="Term"
 body="This Agreement shall be effective as of the Effective Date and shall be terminated when all PHI provided to Business Associate by Covered Entity, or created or received by Business Associate on behalf of Covered Entity, is destroyed or returned to Covered Entity."
/>
<SectionContract
 data-testid="Contract.SectionContract:98"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="6.2."
 title="Termination for Cause"
 body="Upon Covered Entity’s discovery of a material breach by Business Associate, Covered Entity shall either:"
/>
<SectionContract
 data-testid="Contract.SectionContract:99"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="A."
 body="Provide an opportunity for Business Associate to cure the breach or end the violation, and terminate this Agreement if Business Associate does not cure the breach or end the violation within the time specified by Covered Entity; or"
/>
<SectionContract
 data-testid="Contract.SectionContract:100"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="B."
 body="Immediately terminate this Agreement if Business Associate has breached a material term of this Agreement and cure is not possible."
/>
<SectionContract
 data-testid="Contract.SectionContract:101"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="6.3."
 title="Effect of Termination"
 body="Upon termination of this Agreement for any reason, Business Associate agrees to return or destroy all PHI received from Covered Entity, or created or received by Business Associate on behalf of Covered Entity, maintained by Business Associate in any form.  If Business Associate determines that the return or destruction of PHI is not feasible, Business Associate shall inform Covered Entity in writing of the reason thereof, and shall agree to extend the protections of this Agreement to such PHI and limit further uses and disclosures of the PHI to those purposes that make the return or destruction of the PHI not feasible for so long as Business Associate retains the PHI."
/>
<Title
 data-testid="Contract.Title:10"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE VII INDEMNIFICATION AND INSURANCE"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:102"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="7.1."
 title="Indemnification"
 body="Business Associate shall indemnify, defend, and hold Covered Entity, its employees, directors, trustees, officers, representatives and agents (collectively, the “Indemnitees”) harmless from and against all claims, causes of action, liabilities, judgments, fines, assessments, penalties, damages, awards or other expenses, of any kind or nature whatsoever, including, without limitation, attorney’s fees, expert witness fees, and costs of investigation, litigation or dispute resolution, incurred by the Indemnitees and relating to or arising out of any breach or alleged breach of the terms of this Agreement by Business Associate."
/>
<SectionContract
 data-testid="Contract.SectionContract:103"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="7.2."
 title="Insurance"
 body="If Covered Entity requires, Business Associate shall obtain and maintain insurance coverage against improper uses and disclosures of PHI by Business Associate, naming Covered Entity as an additional insured.  Promptly following a request by Covered Entity for the maintenance of such insurance coverage, Business Associate shall provide a certificate evidencing such insurance coverage."
/>
<Title
 data-testid="Contract.Title:11"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Title`}
 text="ARTICLE VIII MISCELLANEOUS"
 marginTop={50}
/>
<SectionContract
 data-testid="Contract.SectionContract:104"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={20}
 number="8.1."
 title="Additional Terms"
 body="The following terms shall also apply to this Agreement:"
/>
<SectionContract
 data-testid="Contract.SectionContract:105"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="A."
 title="Mitigation"
 body="If Business Associate violates this Agreement or either of the HIPAA Rules, Business Associate agrees to mitigate any damage caused by such breach."
/>
<SectionContract
 data-testid="Contract.SectionContract:106"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="B."
 title="Survival"
 body="The rights and obligations of Business Associate under Section 6.3 of this Agreement shall survive the termination of this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:107"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="C."
 title="Notices"
 body="Any notices pertaining to this Agreement shall be given in writing and shall be deemed duly given when personally delivered to a Party or a Party's authorized representative as listed below or sent by means of a reputable overnight carrier, or sent by means of certified mail, return receipt requested, postage prepaid.  A notice sent by certified mail shall be deemed given on the date of receipt or refusal of receipt.  All notices shall be addressed to the appropriate Party as follows:"
/>
<Body
 data-testid="Contract.Body:20"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 text="If to Business Associate:"
/>
<Body
 data-testid="Contract.Body:21"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 fontWeight={500}
 marginTop={4}
 text="Greyfinch, LLC"
/>
<Body
 data-testid="Contract.Body:22"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 fontWeight={500}
 marginTop={4}
 text="ATTN: Josh Matthews"
/>
<Body
 data-testid="Contract.Body:23"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 fontWeight={500}
 marginTop={4}
 text="610 President Clinton A"
/>
<Body
 data-testid="Contract.Body:24"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 fontWeight={500}
 marginTop={4}
 text="Little Rock, AR 72201"
/>
<Body
 data-testid="Contract.Body:25"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={40}
 marginTop={20}
 text="If to Covered Entity:"
/>
<div
 data-testid="Contract.Vertical:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
 className={`views-block ${styles.Vertical1}`}
>
<LegalName
 data-testid="Contract.LegalName:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/LegalName`}
 marginTop={0}
/>
<div
 data-testid="Contract.Horizontal:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
 className={`views-block ${styles.Horizontal4}`}
>
<Body
 data-testid="Contract.Body:26"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 fontWeight={500}
 marginRight={4}
 marginTop={0}
 text="ATTN:"
/>
<FirstName
 data-testid="Contract.FirstName"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/FirstName`}
/>
<Body
 data-testid="Contract.Body:27"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 fontWeight={500}
 marginRight={4}
 marginTop={0}
 text=","
/>
<LastName
 data-testid="Contract.LastName"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/LastName`}
/>
</div>
<Address
 data-testid="Contract.Address"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Address`}
/>
</div>
<SectionContract
 data-testid="Contract.SectionContract:108"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="D."
 title="Amendment"
 body="This Agreement may not be changed or modified in any manner except by an instrument in writing signed by a duly authorized officer of each of the Parties hereto.  The Parties, however, agree to amend this Agreement from time to time as necessary, in order to allow Covered Entity to comply with the requirements of the HIPAA Rules."
/>
<SectionContract
 data-testid="Contract.SectionContract:109"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="E."
 title="Choice of Law"
 body="This Agreement and the rights and the obligations of the Parties hereunder shall be governed by and construed under the laws of the State of Arkansas without regard to applicable conflict of laws principles."
/>
<SectionContract
 data-testid="Contract.SectionContract:110"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="F."
 title="Assignment of Rights and Delegation of Duties"
 body="This Agreement is binding upon and inures to the benefit of the Parties hereto and their respective successors and permitted assigns.  However, neither Party may assign any of its rights or delegate any of its obligations under this Agreement without the prior written consent of the other Party, which consent shall not be unreasonably withheld or delayed.  Assignments made in violation of this provision are null and void."
/>
<SectionContract
 data-testid="Contract.SectionContract:111"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="G."
 title="Nature of Agreement"
 body="Nothing in this Agreement shall be construed to create (i) a partnership, joint venture or other joint business relationship between the Parties or any of their affiliates, (ii) any fiduciary duty owed by one Party to another Party or any of its affiliates, or (iii) a relationship of employer and employee between the Parties."
/>
<SectionContract
 data-testid="Contract.SectionContract:112"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="H."
 title="No Waiver"
 body="Failure or delay on the part of either Party to exercise any right, power, privilege or remedy hereunder shall not constitute a waiver thereof.  No provision of this Agreement may be waived by either Party except by a writing signed by an authorized representative of the Party making the waiver."
/>
<SectionContract
 data-testid="Contract.SectionContract:113"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="I."
 title="Severability"
 body="The provisions of this Agreement shall be severable, and if any provision of this Agreement shall be held or declared to be illegal, invalid or unenforceable, the remainder of this Agreement shall continue in full force and effect as though such illegal, invalid or unenforceable provision had not been contained herein."
/>
<SectionContract
 data-testid="Contract.SectionContract:114"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="J."
 title="No Third-Party Beneficiaries"
 body="Nothing in this Agreement shall be considered or construed as conferring any right or benefit on a person not party to this Agreement nor imposing any obligations on either Party hereto to persons not a party to this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:115"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="K."
 title="Headings"
 body="The descriptive headings of the articles, sections, subsections, exhibits and schedules of this Agreement are inserted for convenience only, do not constitute a part of this Agreement and shall not affect in any way the meaning or interpretation of this Agreement."
/>
<SectionContract
 data-testid="Contract.SectionContract:116"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="L."
 title="Entire Agreement"
 body="AThis Agreement, together with all exhibits, riders and amendments, if applicable, which are fully completed and signed by authorized persons on behalf of both Parties from time-to-time while this Agreement is in effect, constitutes the entire agreement between the Parties hereto with respect to the subject matter hereof and supersedes all previous written or oral understandings, agreements, negotiations, commitments, and any other writing and communication by or between the Parties with respect to the subject matter hereof.  In the event of any inconsistencies between any provisions of this Agreement in any provisions of the exhibits, riders, or amendments, the provisions of this Agreement shall control."
/>
<SectionContract
 data-testid="Contract.SectionContract:117"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="M."
 title="Interpretation"
 body="Any ambiguity in this Agreement shall be resolved in favor of a meaning that permits Covered Entity to comply with the HIPAA Rules and any applicable state confidentiality laws.  The provisions of this Agreement shall prevail over the provisions of any other agreement that exists between the Parties that may conflict with, or appear inconsistent with, any provision of this Agreement or the HIPAA Rules."
/>
<SectionContract
 data-testid="Contract.SectionContract:118"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="N."
 title="Regulatory References"
 body="A citation in this Agreement to the Code of Federal Regulations shall mean the cited section as that section may be amended from time-to-time."
/>
<SectionContract
 data-testid="Contract.SectionContract:119"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/SectionContract`}
 marginLeft={40}
 number="O."
 title="Execution"
 body="This Agreement may be executed in multiple counterparts, each of which shall constitute an original and all of which shall constitute but one agreement."
/>
<Body
 data-testid="Contract.Body:28"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Body`}
 marginLeft={20}
 text="IN WITNESS WHEREOF, the undersigned have set their hands and signatures as of the day and year first above written."
/>
<div
 data-testid="Contract.Vertical:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
 className={`views-block ${styles.Vertical2}`}
>
<Checkbox
 data-testid="Contract.Checkbox"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Checkbox`}
 onClick={data.onChange}
 isSelected={data.value}
 text="I understand I am signing two agreements:"
 fontSize={16}
/>
<Info
 data-testid="Contract.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Info`}
 marginLeft={35}
 marginTop={8}
 text="1) Greyfinch administrative services agreement"
/>
<Info
 data-testid="Contract.Info:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/AddItem/Content/Signature/TermsAndConditions/MemberGroupContract/Contract"
viewPath={`${viewPath}/Info`}
 marginLeft={35}
 marginTop={8}
 text="2) Greyfinch business associate agreement"
/>
</div>
</div>
{children}
</React.Fragment>)
}